<template>
  <div id="analise">
    <div class="contant-analise" v-if="!error">
      <div aria-live="assertive" role="alert" class="announce" style="position: absolute; left: -9999px;">
        {{ mensagem }}
      </div>
        <h1 class="titulo">{{titulo}}</h1>
        <p class="subtitulo">{{subtitulo}}</p>
      <div class="animacao">
        <img class="img img-fluid" src="@/assets/img/analise/meuvivo.gif">
      </div>
    </div>

    <div class="page-error" v-if="error">
      <Error
          title="Algo deu errado ao enviar a foto"
          :subtitle="errorSubtitulo"
          button-text="Tentar de novo"
          v-bind:callback="enviarDados"
      ></Error>
    </div>
  </div>
</template>

<script>

import CapturaService from "../../services/CapturaService";
import DispatchTags from "../../utils/DispatchTags";
import Error from "../shared/Error";

const TEXTO = {
  preprando: "Preparando foto para envio",
  analisando:"Analisando foto enviada",
  enviando: "Enviando foto pra análise"
}

export default {
  name: "Analise",
  components: {Error},
  data:function (){
    return {
      titulo: TEXTO.preprando,
      subtitulo: 'Continue nesta tela enquanto analisamos',
      errorSubtitulo:'',
      error: false,
      tentativa:1,
      redirectDoc:false,
      redirectSelfie:false,
      mensagem:'',
    }
  },
  computed:{
    getDados:function (){
      return this.$store.getters.dados;
    }
  },
  mounted() {
    this.$store.dispatch('setLoadingStatus',false);
    this.$store.dispatch('setTitulo','Confirmar identidade');
    DispatchTags.dispatchScreenView('Analise');
    this.exibirMensagem('Aguarde um momento, a imagem está sendo enviada para análise.');
    this.enviarDados();
  },
  methods:{
    exibirMensagem(mensagem){
      this.mensagem = mensagem;
      setTimeout(() =>{
        this.mensagem = '';
      },100);
    },
    enviarDados:function (){
      if(this.redirectSelfie){
        this.redirectSelfie = false;
        this.$router.replace({name: 'ConfirmarIdentidade'});
        return;
      }

      if(this.redirectDoc){
        this.redirectDoc = false;
        this.$router.replace({name: 'DocSelecao'});
        return;
      }

      this.titulo = TEXTO.preprando;
      this.error = false;
      let capturaService = new CapturaService();

      let dados  = (( { id_link,
                        chave,
                        dados1N,
                        ind_api_n1,
                        tipo_doc,
                        voz_cadastrada,
                        ind_excecao_pre_pago,
                        is_caf }) => ( {id_link,
                                        chave,
                                        dados1N,
                                        ind_api_n1,
                                        tipo_doc,
                                        voz_cadastrada,
                                        ind_excecao_pre_pago,
                                        is_caf }))(this.getDados);

      dados.selfie = sessionStorage.getItem('s');
      dados.selfie_msg = sessionStorage.getItem('selfie_msg');
      dados.selfie_id = sessionStorage.getItem('selfie_id');
      if(!dados.selfie || (!dados.is_caf && !this.validarArquivo(dados.selfie))){
        this.redirectSelfie = true;
        this.errorSubtitulo = "Não conseguimos recuperar sua selfie, você vai precisar capturar ela novamente";
        this.error = true
        this.$store.dispatch("limparDadosSelfie");
        return;
      }

      let api1NLigada = (parseInt(this.$store.state.ind_api_n1) === 1);
      if((this.$store.getters.tipoCaptura === 1 && !api1NLigada) || (this.$store.getters.resposta1N && api1NLigada)){
        dados = this.validarDocumentos(dados);
      }


      this.titulo = TEXTO.enviando;
      Promise.all([capturaService.enviarDigitalizacao(dados)])
          .then(result => result[0])
          .then(result => {
            if(result.type === "error") {
              return Promise.reject(result);
            }
            if(result.enviarMotor){
              return capturaService.enviarMotorBio(dados.chave,result.protocolo,dados.id_link, dados.dados1N);
            }
            return Promise.resolve();
          })
          .then(_  =>  {
            this.titulo = TEXTO.analisando;
            this.redireciona(false)
          })
          .catch(error => {
            if(error.type && error.type === "error" && this.tentativa < 3) {
              this.exibirErro(error.description);
              return;
            }

            this.redireciona(true);
          });
    },
    validarArquivo:function (dataurl){
      try{
        let arr = dataurl.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);
        while(n--){
          u8arr[n] = bstr.charCodeAt(n);
        }
        let file = new File([u8arr], 'testefile', {type:mime});
        let types = ['image/jpeg','image/tiff','image/png'];
        return types.includes(file.type);
      }catch (e) {
        return false;
      }
    },
    tratarURL(url){
      if (url.indexOf("http://") == -1 && url.indexOf("https://") == -1) {
        return `https://${url}`;
      }
      return url;
    },
    redireciona:function (error){
      var user = this.$store.getters.getUser.toLocaleString();
      var URL =  this.$store.getters.getUrlRetorno;
      var isJornadaCompleta = this.$store.getters.isJornadaCompleta ? 'doc' : 'selfie'

      if(user.toLocaleString() == "meuvivonl"){
        var checkParams = this.checkUrlParams(URL)
        var tipoCaptura = checkParams ? '&typeBiometry=' : '?typeBiometry='

        sessionStorage.clear();
        this.$store.dispatch('resetState');
        window.location.replace(this.tratarURL(URL) + tipoCaptura + isJornadaCompleta);
        return;
      }
      //Posição [0] = callback de sucesso
      //Posição [1] = callback de falha
      var URL_RETORNO =  this.$store.getters.getUrlRetorno.split('$');
      sessionStorage.clear();
      this.$store.dispatch('resetState');
      var url = (error) ? URL_RETORNO[1] : URL_RETORNO[0];
      if(user.toLocaleString() === "svc_vivoeasy"){
        url = URL+'?success='+(!error).toString();
      }
      var checkParams = this.checkUrlParams(url)
      var tipoCaptura = checkParams ? '&typeBiometry=' : '?typeBiometry='
      window.location.replace(this.tratarURL(url) + tipoCaptura + isJornadaCompleta);
    },
    checkUrlParams: function (url) {
      return url.match(/[?&][^&=]+(=[^&]*)?/g)
    },
    exibirErro:function (desc){
      this.error = true;
      this.tentativa++;
      DispatchTags.dispatchInraction('Analise');
      this.titulo = TEXTO.preprando;
      this.errorSubtitulo = (desc) ? desc : 'Você pode tentar de novo';
    },
    validarDocumentos:function (dados){
      dados.docA = sessionStorage.getItem('A');
      dados.docB = sessionStorage.getItem('B');
      dados.docCNHDIGITAL = this.$store.getters.dados.cnh_digital_base;

      if (dados.docCNHDIGITAL){
        dados.tipo_doc = 'cnh-digital';
      }else{
        if(!dados.docA || !dados.docB  || !this.validarArquivo(dados.docA) || !this.validarArquivo(dados.docB)){
          this.redirectDoc = true;
          this.errorSubtitulo = "Não conseguimos recuperar as fotos do seu documento, você vai precisar capturar elas novamente.";
          this.error = true
          sessionStorage.removeItem('A');
          sessionStorage.removeItem('B');
          return;
        }
      }
      return dados;
    },
  },
}
</script>

<style scoped>


.hidden{
  display: none;
}

#analise{
  margin-top: 5rem;
}

.animacao {
  position: relative;
  width: 18.75rem;
  height: 18.75rem;
  margin: 0 auto;
}

.animacao img {
  position: relative;
  height: 100%;
  margin: 0 auto;
  display: block;
}

</style>



// WEBPACK FOOTER //
// src/components/pages/Analise.vue